// extracted by mini-css-extract-plugin
export default {"modalFooter":"webpack-concepts-Extraction-Blocks-shared-DeleteBlockWarningDialog-module__modalFooter"};